export const loveMessages = [
  "Je t'aime",
  "Mon coeur",
  "Ma vie",
  "Pour toujours",
  "Tu me manques",
  "Mon amour",
  "Tu es belle",
  "Mon trésor",
  "Je t'adore",
  "Mon ange",
  "Tu es tout pour moi",
  "Mon bonheur",
  "Ma princesse",
  "Mon étoile",
  "Je suis fou de toi",
  "Mon soleil",
  "Ma moitié",
  "Mon univers",
  "Tu illumines ma vie",
  "Mon âme soeur"
]
